var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 91,
    viewBox: "0 0 89 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3597",
    "data-name": "Group 3597",
    transform: "translate(-1162 -754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VOTRE_SCORE",
    "data-name": "VOTRE SCORE",
    transform: "translate(538.689 333.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1413",
    "data-name": "Rectangle 1413",
    transform: "translate(628.311 425.515)",
    fill: "#579f2a",
    stroke: "#ddd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 81,
    rx: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.5,
    y: -2.5,
    width: 84,
    height: 86,
    rx: 19.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-check-mark-1",
    d: "M48.553,120.526,21.542,148.212,8.89,136.218,0,145.113,21.542,166l35.9-36.585Z",
    transform: "translate(1177.51 655.44)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.ae8e6e81.svg";
export { ForwardRef as ReactComponent };